import { UPLOAD_ENTITY_TYPES } from "slices/documentUploads/documentUploadsSlice";

export const OUTLINE_ITEM_ENTITY_TYPE = "PROPOSAL_OUTLINE_ITEM";

export const ENTITY_TYPE_PATH = {
  [UPLOAD_ENTITY_TYPES.OPPORTUNITY]: "opportunity",
  [UPLOAD_ENTITY_TYPES.PROPOSAL]: "proposal",
  [UPLOAD_ENTITY_TYPES.CONTRACT]: "contract",
  [UPLOAD_ENTITY_TYPES.MISC_ANALYSIS]: "misc-analysis",
  [UPLOAD_ENTITY_TYPES.MISC_ANALYSIS_RESEARCH]: "misc-analysis",
  [UPLOAD_ENTITY_TYPES.MISC_ANALYSIS_PROPOSAL_WRITING]: "misc-analysis",
  [OUTLINE_ITEM_ENTITY_TYPE]: "proposal-outline-item",
};
